export const hash = (obj: any): string => {
  return JSON.stringify(obj || {});
};
